import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_LONG_FORM_BUILDER_DRAFT } from './schema';

const MUTATION = gql`
  mutation NameLongFormBuilderDraft($projectId: ID!, $draftId: ID!, $name: String!) {
    nameLongFormBuilderDraft(projectId: $projectId, draftId: $draftId, name: $name) {
      ...LongFormBuilderDraft
    }
  }
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
`;

export const nameLongFormBuilderDraft = ({ projectId, draftId, name }) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { projectId, draftId, name },
  }).then(({ data }) => getSingleProp(data));
};
